import React, { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Spinner, Title, ActionButton } from "../../../components/atoms";
import { Modal } from "react-responsive-modal";
import {
  SideBackNav,
  VerticalPrintAddress,
} from "../../../components/organisms";
import {
  PrintProductList,
  PrintItemsList,
  PrintHeader,
  AnchorLink,
} from "../../../components/molecules";
import { useLocation } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { GETNEWORDERS, GETPRODUCTURL } from "../../../api/apiConfig";
import {
  apiPost,
  printLabel1,
  appTitle,
  notificationSchedulerTime,
  businessAddress,
  businessEmail,
  businessUrl,
  AnalyticsService,
  getNotifications,
} from "../../../utils";
import { Grid } from "@mui/material";
import { useMediaQuery } from "react-responsive";
import {PrintAllSlipInOne} from "./PrintAllSlipInOne";

const PackagingSlip = () => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 900px)' })
  const [dateToday, setDateToday] = useState(moment().format("h:mm a"));
  const [showReturnLabels, setShowReturnLabels] = useState(false);
  const [data, setData] = useState();
  const [link, setLink] = useState();
  const [printLabelOnce, setPrintLabelOnce] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const vendor = localStorage.getItem("userName");
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    customer,
    orderNumber,
    customerAddress,
    billing,
    orderId,
    shipLabel,
    returnLabel,
    order
  } = state;
  const numOfNewOrders = useSelector(
    (state) => state.notifications.numOfNewOrders
  );

  const getNewOrders = async () => {
    const res = await apiPost(GETNEWORDERS, { vendor: "The Cricket Store" });
    if (res) {
      const order = res.find((e) => e.orderId === orderId);
      setData(order);
    }
  };
  const getProductDetails = async () => {
    
    const res = await apiPost(GETPRODUCTURL, { orderId: orderId, vendor });
    if (res) {
      
      const promises = res.map(async (product, index) => {
        product.images[0].src = await imageUrlToBase64(product.images[0].src);
    });
        
    await Promise.all(promises);
    
      setLink(res);
    }
    
  };

  useEffect(async () => {
    AnalyticsService.logEvent("PACKAGING_SLIP_PAGE_VIEW");
    setIsLoading(true);
   // await getNewOrders();
   
   setPrintLabelOnce(order.printAllLabelsAtOnce);
    setData(order);
    await getProductDetails();
    setIsLoading(false);
    setInterval(() => {
      setDateToday(moment().format("h:mm a"));
    }, 1000);

    return () => {
      setDateToday("");
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(
      () => getNotifications(numOfNewOrders, dispatch, navigate),
      notificationSchedulerTime
    );
    return () => clearInterval(interval);
  }, [numOfNewOrders]);

  const onBack = () => {
    navigate("/dashboard");
    AnalyticsService.logEvent("PACKAGING_SLIP_BACK_TO_DASHBOARD_NAVIGATION");
  };
  const onPrintBtnClick = async () => {
    if(isLoading) return;

    if(printLabelOnce)
    {    
      const bodyCopy = document.getElementById('PrintSection');
      
      let returnLabel_ = null;
      if (returnLabel) {
        const returnLabels = returnLabel.split(";");
        returnLabel_ = returnLabels[0];
      }

      const shippingLabel = order.isService ? returnLabel_ : shipLabel;
      
      await PrintAllSlipInOne(bodyCopy, shippingLabel, returnLabel_);
    }
    else{
      window.print();
    }
    
    AnalyticsService.logEvent("WINDOW_PRINT_CLICKED");
  };

  const onPrintFedExShippingClick = () => {
    
    if(isLoading) return;
    document.getElementById("shipLabel").click();
  };

  const onPrintFedExReturnClick = () => {
    if(isLoading) return;
    setShowReturnLabels(true);
    // document.getElementById("returnLabel").click();
  };
  async function imageUrlToBase64(imageUrl) {
    try {
        // Fetch image data from the URL
        const response = await fetch(imageUrl);
        const blob = await response.blob();

        // Convert blob to base64 string
        const reader = new FileReader();
        reader.readAsDataURL(blob);

        return new Promise((resolve, reject) => {
            reader.onloadend = () => {
                resolve(reader.result);
            };
            reader.onerror = reject;
        });
    } catch (error) {
        console.error('Error fetching image:', error);
        return imageUrl; // Return original URL on error
    }
}
  const returnLabels = returnLabel?.split(";");
  return (
    <>
    <div id="packingSlipElement">

    
      <Modal 
        open={showReturnLabels}
        onClose={() => setShowReturnLabels(false)}
        center
      >
        <div>
          <h2 className="mb-1">Return Labels</h2>
          <ul>
            {returnLabels?.map((label, index) => {
              return (
                <li>
                  <a target="_blank" href={label}>
                    Download Return Label {index + 1}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </Modal>
      <div  className="topPrintNav" >
        <div style={{marginTop:'20px',marginLeft:isTabletOrMobile &&'-25px'}}>
          <SideBackNav title={"Back"} onClick={onBack} />
        </div>
        <div  style={{position:'relative',width:"100%"}}>
        <Grid container spacing={2} style={{position:'fixed',top:'10px',width:'80%',left: printLabelOnce ? !isTabletOrMobile?'550px':'270px' : !isTabletOrMobile?'200px':'50px'}}>
         <Grid item md={"auto"} xs={4}>
          <ActionButton
              text={printLabelOnce ? "Print All Labels" :"Print Packaging Slip"}
              className={"printBtnCls"}
              onClick={onPrintBtnClick}
            />
         </Grid>
         {printLabelOnce ? (<div></div>) : (<Grid item xs={4} md={"auto"} >
          <ActionButton
              text={"Print Shipping Label"}
              className={"printBtnCls"}
              onClick={onPrintFedExShippingClick}
            />
         </Grid>)}
         {printLabelOnce ? (<div></div>) : (<Grid item xs={4} md={"auto"}>
          <ActionButton
            text={"Print Return Label"}
            className={"printBtnCls"}
            onClick={onPrintFedExReturnClick}
          />
          </Grid>)}
         
        </Grid>
        </div>
       
        <div className="printShippingLabelRow"></div>

        <a id="shipLabel" href={order.isService ? returnLabel : shipLabel} target="_blank"></a>
        <a id="returnLabel" href={returnLabel} target="_blank"></a>
        {/* <AnchorLink
          className={"labelLink"}
          text={"Print Shipment Label"}
          url={shipLabel}
        />
        {returnLabel.split(";").length === 1 && (
          <AnchorLink
            className={"labelLink"}
            text={"Print Return Label"}
            url={returnLabel}
          />
        )}
        {returnLabel.split(";").length > 1 &&
          returnLabel.split(";").map((m, i) => {
            return (
              <AnchorLink
                key={i}
                className={"labelLink"}
                text={`Print Return Label ${i + 1}`}
                url={m}
              />
            );
          })}
        */}
      </div>
      <div id="PrintSection" style={{marginTop:'100px'}}>
        <div  className="printSection">
          <PrintHeader
            title={"The cricket store"}
            orderNumber={orderNumber}
            dateToday={moment().format("Do MMM YYYY")}
          />
          <div className="printAd">
            <VerticalPrintAddress
              label={"SHIP TO"}
              address1={customerAddress?.address1 || "N/A"}
              address2={customerAddress?.address2 || "N/A"}
              postalCode={customerAddress?.zip || "N/A"}
              city={customerAddress?.city || "N/A"}
              country={customerAddress?.country || "N/A"}
              ifText
              text={customerAddress?.phone || "N/A"}
              ifCustomerName
              customerName={customer || "N/A"}
            />
            <VerticalPrintAddress
              label={"BILL TO"}
              address1={billing?.address1 || "N/A"}
              address2={billing?.address2 || "N/A"}
              postalCode={billing?.zip || "N/A"}
              city={billing?.city || "N/A"}
              country={billing?.country || "N/A"}
              ifCustomerName
              customerName={customer || "N/A"}
            />
          </div>
          <div className="printSpinner">
            <Spinner color={"black"} loading={isLoading} size={40} />
          </div>
          <div className="printAd spacing">
            <div>
              <Title text={"ITEMS"} className="printTopTitle" />
              {link &&
                link
                  .filter((link) => {
                    
                    const lineItems = data?.lineItems.filter(
                      (a) => a.status !== 5
                    );
                    
                    const foundLink = lineItems?.find(
                      (a) => a.variantTitle
                      === link.variantTitle

                    );
                    
                    return foundLink;
                  })
                  .map((e, productUrl) => {
                   
                    return (
                      <PrintProductList
                        key={productUrl}
                        productName={e.productName || "N/A"}
                        variantName ={e.variantTitle}
                        productImage={
                          e.images && e.images.length > 0
                            ? e.images[0].src
                            : undefined
                        }
                        isImage={e.images && e.images.length > 0 ? true : false}
                      />
                    );
                  })}
            </div>
            <div>
              <Title text={"QUANTITY"} className="printTopTitle" />
              {data && (
                <div>
                  {data.lineItems &&
                    data.lineItems
                      .filter((e) => e.status !== 5)
                      .map((e, name) => (
                        <PrintItemsList
                          key={name}
                          label={"QUANTITY"}
                          quantity={`${e.quantity} of ${e.quantity}` || "N/A"}
                        />
                      ))}
                </div>
              )}
            </div>
          </div>
          <div className="printFooter">
            <Title text={printLabel1} className="printfooterText text" />
            <Title text={appTitle} className="printFooterBold text" />
            <Title text={businessAddress} className="printFooterNormal text" />
            <Title text={businessEmail} className="printFooterNormal text" />
            <Title text={businessUrl} className="printFooterNormal text" />
          </div>
        </div>
      </div>
      </div>
    </>
  );
};
export default PackagingSlip;
